import * as React from 'react'
import styled from 'styled-components'
import {
    Container,
    Heading,
    Li,
    List, ModalMUI,
    ReadMore,
    Title, Title2,
} from '../sharedStyles'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NotFound } from './PersonalizedHealthEval'
import { ConfigText } from './HealthStatus'
import { TextLinkify } from "./RecomendAndNextSteps";
import { fixUploadUrlsInHtml } from '../utils/appHelpers';

const Background = styled.div`
  width: 100%;
`

const BodyResult = styled.div`
  margin-top: 0;
`

const ResultsInterpretation = (props: any) => {
    const { t, i18n } = useTranslation()
    const { themeId } = props
    const [readMore, setReadMore] = useState<any>({})
    const { info } = props
    const isOk = (info.interpretations || []).length > 0

    const interpretations = themeId
        ? info.interpretations.filter((it: any) => {
            const subjectId = (it.subjectIds || [])[0];
            return themeId == subjectId
          })
        : info.interpretations;

    return (
        <div style={{ background: '#fff' }}>
            <Background>
                <div data-animch='3' className={'pf pfsmall'}>
                    <Title2 data-title2>
                        <ConfigText field={'your_results_interpretaion'}>{t('yourResultsInterpretation')}</ConfigText>
                    </Title2>
                    <BodyResult>
                        {isOk && <>
                            <div>
                                {(interpretations || [])
                                    .filter((item: any) => item.name)
                                    .map((it: any, ind: number) => {
                                        let description = '';
                                        if (it.description) {
                                            if (typeof it.description === 'string') {
                                                description = it.description;
                                            } else if (typeof it.description === 'object') {
                                                const currentLang = i18n.language;
                                                description = it.description[currentLang] || it.description.en || Object.values(it.description)[0] || '';
                                            }
                                        }
                                        let nameStr = '';
                                        if (it.name) {
                                            if (typeof it.name === 'string') {
                                                nameStr = it.name;
                                            } else if (typeof it.name === 'object') {
                                                const currentLang = i18n.language;
                                                nameStr = it.name[currentLang] || it.name.en || Object.values(it.name)[0] || '';
                                            }
                                        }
                                        const text = String(description || nameStr || '')
                                        const shortText = text.slice(0, 200)

                                        const isReadMore = text.length > 200;
                                        const isReadMoreOpen = true;

                                        const actualText = isReadMoreOpen || !isReadMore ? text : shortText

                                        let opts = isReadMoreOpen ? { 'data-fade': true } : {}
                                        return (
                                            <div key={ind} className={'disDesc'}>
                                                <TextLinkify text={actualText}></TextLinkify>
                                            </div>
                                        )
                                    })}
                            </div>
                        </>}
                        {!isOk && <>
                            <NotFound></NotFound>
                        </>}
                    </BodyResult>
                </div>
            </Background>
        </div>
    )
}
const ReadMoreWithHeight = (props: any) => {
    const [isOpen, setIsOpen] = useState(false)
    const [cd, setCd] = useState(0)
    const elRef = React.useRef(null);
    const { text } = props || {};
    const MAX_HEIGHT = 200;

    const el = (elRef?.current || {}) as any;
    const height = el.offsetHeight;
    const isMore = height > MAX_HEIGHT;

    const isMoreVisible = !isOpen && isMore

    React.useEffect(() => {
        setCd(new Date().getTime())
    }, [text])

    const styles = {
        maxHeight: isMoreVisible ? (MAX_HEIGHT + 'px') : 'auto',
        overflow: isMoreVisible ? 'hidden' : 'none',
    }
    return <div className={isMoreVisible ? 'isMoreVisible' : ''}>
        <div ref={elRef} dangerouslySetInnerHTML={{ __html: fixUploadUrlsInHtml(text || '') }} className={'interContent'}>
        </div>
        {isMoreVisible && <a className={'isMoreBtn linkHover'} onClick={() => {
            setIsOpen(true)
        }}>Read More</a>}

    </div>
}

export default ResultsInterpretation
